<template>
    <div class="comparisonTop">
        <div class="smTitle">{{ title }}</div>
        <el-carousel @change="bannerChange" ref="comparisonTopCarousel" :autoplay="false" indicator-position="none"
            trigger="click" :height="height + 'px'">
            <el-carousel-item v-for="item in list" :key="item.id">
                <div class="carouselItem">
                    <div class="topImag">
                        <img v-if="item.type == 1" :src="item.cover" alt="" />
                        <video :src="item.cover" v-else autoplay muted loop webkit-playsinline playsinline
                            x5-video-player-type="h5-page" x5-playsinline="true" preload="auto"
                            :poster="item.cover + '?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
        <div v-if="showTitle == 1" class="comparisonTab">
            <div @click="comparisonBannerChange(index)" :class="index == comparisonBannerIndex ? 'activeItem' : ''"
                v-for="(item, index) in list" class="item">{{ item.title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            comparisonBannerIndex: 0,
            height: 700,
        }
    },
    props: {
        list: {
            type: Array,
            default: (() => [])
        },
        title: {
            type: String,
            default: '',
        },
        showTitle: {
            type: [String, Number],
            default: 2,
        }
    },
    created() {
        let maxWidth = window.innerWidth
        if (maxWidth < 1200) {
            this.height = maxWidth * (7 / 12)
        }
    },
    methods: {
        comparisonBannerChange(i) {
            this.$refs.comparisonTopCarousel.setActiveItem(i)
            this.comparisonBannerIndex = i
        },
        bannerChange(i) {
            this.comparisonBannerIndex = i
        },
    },
}
</script>

<style lang="scss" scoped>
.comparisonTop {
    width: 1200px;
    margin: auto;
    margin-top: 0px;
    margin-bottom: 116px;

    .smTitle {
        font-size: 40px;
        color: #000000;
        line-height: 40px;
        margin-bottom: 38px;
    }

    .topImag {

        img {
            width: 1200px;
            height: 700px;
            display: block;
            object-fit: cover;
        }

        video {
            width: 1200px;
            height: 700px;
            display: block;
            object-fit: cover;
        }
    }

    .comparisonTab {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;

        .item {
            min-width: 200px;
            padding: 18px 0;
            color: #D8D8D8;
            border-bottom: 1px solid #D8D8D8;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
        }

        .activeItem {
            color: #000;
            border-bottom: 2px solid #000;
            font-weight: bold;
        }
    }
}

::v-deep .el-carousel__arrow--left {
    display: none !important;
}

::v-deep .el-carousel__arrow--right {
    display: none !important;
}

@media screen and (max-width:1200px) {
    .comparisonTop {
        width: 100%;
        margin: auto;
        margin-top: 20px;

        .smTitle {
            font-size: 18px;
            color: #000000;
            line-height: 30px;
            margin-bottom: 20px;
        }

        .topImag {
            width: 100%;

            img {
                width: 100%;
                height: auto;
                object-fit: cover;
                display: block;
            }

            video {
                width: 100%;
                height: auto;
                aspect-ratio: 12 / 7;
                display: block;
                object-fit: cover;
            }
        }

        .comparisonTab {
            width: 100%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: nowrap;
            margin-top: 10px;

            .item {
                min-width: 80px;
                padding: 18px 10px;
                box-sizing: border-box;
                max-width: 150px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: #D8D8D8;
                border-bottom: 1px solid #D8D8D8;
                text-align: center;
                font-size: 12px;
                cursor: pointer;
            }

            .activeItem {
                color: #000;
                border-bottom: 1px solid #000;
            }
        }
    }
}
</style>